import styled from "styled-components";

const PersonalInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 100%;
`

export const S = {
    PersonalInfoWrapper
}